export default "__VITE_ASSET__TClcEGFc__"